import { required } from "../../../../../../../shared/utils/forms/utils/validationType";

export const useValidationVoxiSudFooter = (t: any) => {
  return [
    {
      name: "validUntil",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.validUntil")
          }
        }
      ]
    },
    {
      name: "dataProssimoControllo",
      validations: [
        {
          name: required,
          params: {
            name: t("voxiSud.dataProssimoControllo")
          }
        }
      ]
    },
    {
      name: "tipoPrescrizione",
      validations: [
        {
          name: required,
          params: {
            name: t("voxiSud.tipoPrescrizione.label")
          }
        }
      ]
    }
  ];
};
